/* eslint-disable import/prefer-default-export */

import { httpService } from 'core-utilities';
import { Result } from '../../result';
import { toResult } from '../common';
import * as Email from '../types/email';

export const updateForCurrentUser = (
  emailAddress: string
): Promise<Result<void, Email.EmailError | null>> =>
  toResult(
    httpService.post(Email.UPDATE_FOR_CURRENT_USER_CONFIG, {
      emailAddress,
      skipVerificationEmail: true
    }),
    Email.EmailError
  );
